module.exports = __webpack_public_path__ + "static/media/DSC_0222.fb598751.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0222.jpg
// module id = 694
// module chunks = 0